import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { useApi } from '@/lib/api-context';

import { trainingStageResponseSchema, type TrainingStage } from './training-stage';

interface Options {
  companyId: string | null;
  enabled: boolean;
}

/** Etapa de capacitación del documento (G4): alimenta el stepper, la ficha y la vigencia
 *  sugerida del modal de firma. */
export function useTrainingStage(
  entryId: string,
  { companyId, enabled }: Options,
): UseQueryResult<TrainingStage> {
  const api = useApi();
  return useQuery({
    queryKey: ['training-stage', companyId, entryId],
    queryFn: async () => {
      const raw = await api.get<unknown>(`/api/v1/quality/documents/${entryId}/training-stage`);
      return trainingStageResponseSchema.parse(raw).data;
    },
    enabled,
  });
}
